import { render, staticRenderFns } from "./search-popover-common.vue?vue&type=template&id=88e23b0a&scoped=true"
import script from "./search-popover-common.vue?vue&type=script&lang=js"
export * from "./search-popover-common.vue?vue&type=script&lang=js"
import style0 from "./search-popover-common.vue?vue&type=style&index=0&id=88e23b0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e23b0a",
  null
  
)

export default component.exports